module.exports = __webpack_public_path__ + "static/img/Member distribution.1c7426b6.png";